<template>
  <div class='table-box'>
    <QueryForm
      @QuerySearch='QuerySearch'
      :queryForm='queryForm'
      :typeN="1"
    ></QueryForm>
    <div
      class='map_right'
      id='container'
    ></div>
    <!-- 弹窗 end -->
    <shipingtonghua
      v-if="videoModal"
      :userId="userinfo.id"
      :mobilePhone='userinfo.personPhone'
      :closeSP.sync="videoModal"
    ></shipingtonghua>
  </div>
</template>

<script>
import request from '@/utils/request'
import QueryForm from '@/component/queryform3.vue'
import shipingtonghua from "@/components/shipingtonghua.vue"

export default {
  components: {
    QueryForm,
    shipingtonghua,
  },
  data() {
    return {
      map: null,
      markers: [],
      queryForm: {
        provinceId: '',
        cityId: '',
        zoneId: '',
        streetId: '',
        shequId: '',
        address: ''
      },
      videoModal: false,
      userinfo: {}
    }
  },
  mounted() {
    this.mapInit()
  },
  methods: {
    showVideo(item) {
      this.userinfo = item
      this.videoModal = true
    },
    QuerySearch() {
      if(this.map) {
        this.map.clearMap()
      }
      this.getPerson()
    },
    //加载地图
    mapInit() {
      return new Promise((resolve, reject) => {
        this.map = new AMap.Map('container', {
          resizeEnable: true,
          zoom: 12
        })
        this.map.on('complete', () => {
          this.getPerson()
          resolve()
        })
      })
    },
    //服务人员
    getPerson(id) {
      request({
        url: '/jjyl/admin/serviceStaffCustomerCenter/info/findList',
        method: 'POST',
        data: {
          ...this.queryForm,
          pageNo: 1,
          pageSize: 10000,
        }
      }).then((res) => {
        if (res.code == 200) {
          let personList =[]
          if(res.content && res.content !==null){
            personList = res.content.elderList.list || []
            personList.forEach(item => {
            const icon = new AMap.Icon({
              image: require(item.status === '1' ? '@/assets/img/map/map-person2.png' : '@/assets/img/map/map-person1.png'),
              imageSize: new AMap.Size(22, 30)
              // imageOffset: new AMap.Pixel(-95, -3)
            })
            const marker = new AMap.Marker({
              map: this.map,
              icon: icon,
              // position: [116.473188, 39.993253]
              position: [
                Number(item.longitude),
                Number(item.latitude),
              ],
            })
            this.markers.push(marker)

            marker.on('click', async e => {
              let html = ''
              let data = null
              if(item.status === '1') {
                await this.$http
                  .request({
                    url: "jjyl//admin/serviceStaffCustomerCenter/info/getServerPersonById",
                    method: "POST",
                    data: {
                      id: item.id
                    },
                  })
                  .then(async (res) => {
                    if (res.code == 200) {
                      data = res.content.pgd
                    } else {
                      this.$message.error(res.message)
                    }
                  })
              }

              const content = `<div class='map-modal' style='width: 300px'>
                                ${data ? `<p>订单号：${data.orderNum}</p>` : ''}
                                <p class='m-t10'>联系人：${item.personName}</p>
                                <p class='m-t10'>联系电话：${item.personPhone}</p>
                                ${data ? `<div>
                                  <p class='m-t10'>服务对象：${data.customerName}</p>
                                  <p class='m-t10'>服务内容：${data.servetypename}</p>
                                </div>` : ''}
                                <button class='m-t10' onclick='showVideo()'}>视频通话</button>
                              </div>`

              const infowindow = new AMap.InfoWindow({
                content: content,
                offset: new AMap.Pixel(0, -30)
              })
              infowindow.open(this.map, [
                Number(item.longitude),
                Number(item.latitude),
              ])

              window.showVideo = () => {
                this.showVideo(item)
              }
            })
          })
         this.map.setFitView(this.markers)
          }
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>
#container {
  width: 100%;
  height: calc(100vh - 200px);
}

/deep/ .map-modal {
  button {
    cursor: pointer;
    color: #fff;
    background-color: #409eff;
    border: none;
    padding: 5px 10px;
  }
}
</style>
